import React from 'react';
import { Zap, CheckCircle, Loader2 } from 'lucide-react';

interface HookOptimizerProps {
  hooks: string[];
  isLoading?: boolean;
  onSelectHook: (hook: string) => void;
  currentHook?: string;
}

export const HookOptimizer: React.FC<HookOptimizerProps> = ({ hooks, isLoading, onSelectHook, currentHook }) => {
  if (isLoading) {
    return (
      <div style={{
        padding: 'var(--space-4)', borderRadius: 12,
        background: 'rgba(245,158,11,0.06)', border: '1px solid rgba(245,158,11,0.15)',
      }}>
        <div className="flex items-center gap-2">
          <Loader2 size={14} className="spin" style={{ color: '#F59E0B' }} />
          <span style={{ fontSize: 12, color: '#F59E0B' }}>Hooks werden optimiert...</span>
        </div>
      </div>
    );
  }

  if (hooks.length === 0) return null;

  return (
    <div style={{
      padding: 'var(--space-4)', borderRadius: 12,
      background: 'rgba(245,158,11,0.06)', border: '1px solid rgba(245,158,11,0.15)',
    }}>
      <div className="flex items-center gap-2" style={{ marginBottom: 'var(--space-3)' }}>
        <Zap size={14} style={{ color: '#F59E0B' }} />
        <span style={{ fontSize: 12, fontWeight: 600, color: '#F59E0B' }}>
          Hook-Alternativen ({hooks.length})
        </span>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {hooks.map((hook, i) => {
          const isSelected = hook === currentHook;
          return (
            <div
              key={i}
              onClick={() => onSelectHook(hook)}
              style={{
                padding: '8px 12px', borderRadius: 8, cursor: 'pointer',
                border: isSelected ? '1px solid #F59E0B' : '1px solid rgba(255,255,255,0.06)',
                background: isSelected ? 'rgba(245,158,11,0.1)' : 'rgba(255,255,255,0.02)',
                fontSize: 13, lineHeight: 1.4,
                transition: 'all 0.15s ease',
              }}
              onMouseEnter={(e) => {
                if (!isSelected) (e.currentTarget.style.borderColor = 'rgba(245,158,11,0.3)');
              }}
              onMouseLeave={(e) => {
                if (!isSelected) (e.currentTarget.style.borderColor = 'rgba(255,255,255,0.06)');
              }}
            >
              <div className="flex items-center justify-between">
                <span style={{ fontWeight: isSelected ? 600 : 400 }}>{hook}</span>
                {isSelected && <CheckCircle size={12} style={{ color: '#F59E0B', flexShrink: 0 }} />}
              </div>
            </div>
          );
        })}
      </div>
      <div style={{ fontSize: 10, color: 'var(--text-muted)', marginTop: 8 }}>
        💡 Klicke auf einen Hook um ihn als erste Zeile deiner Caption zu setzen.
      </div>
    </div>
  );
};
